import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import ReactApexChart from "react-apexcharts";
import { NoData } from "./NoData";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { currencyFormat, exportChatFile, downloadImageCommon, numDifferentiation } from "../../../../helpers/utilities";
import useMediaQuery from '@mui/material/useMediaQuery';
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    Virtual
} from "swiper/core";
SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);


export const NetGST = (props) => {
    const { title, details } = props;
    const netGST = useRef(null);
    const classes = customStyles();
    const [data, setData] = useState(1);
    const [datas, setDatas] = useState('');
    const mobileDevice = useMediaQuery('(min-width:1400px)');

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(netGST.current, title, type);
        }
    }

    const handleChange = (value) => {
        if (value === 'one_month') {
            setData(1);
        } else if (value === 'three_months') {
            setData(3);
        } else if (value === 'twelve_months') {
            setData(12);
        }
        setDatas(details?.gst_month[value]);
    }

    useEffect(() => {
        if (details)
            setDatas(details?.gst_month['one_month']);
    }, [details]);



    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total']];
        exportChatFile(title, newHead);
    }

    const chartData = {
        chart: {
            type: "line",
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: [],
                }
            }
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '13px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box">' +
                    '<div class="invoices"><div>GST Payable</div><div>₹ ' + currencyFormat(series[0][dataPointIndex]) + '</div></div>' +
                    '<div class="invoice_amount"><div>GST Receivables</div><div>₹ ' + currencyFormat(series[1][dataPointIndex]) + '</div></div>' +
                    '</div>';
            }
        },
        legend: {
            show: true,
            fontSize: 11,
            fontWeight: 500,
            position: 'top',
            horizontalAlign: 'right',
            markers: {
                width: 10,
                height: 10,
                radius: 0,
                offsetY: 0
            },
        },
        plotOptions: {
            bar: {
                columnWidth: '80%',
            }
        },
        fill: {
            opacity: 1
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent']
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 1,
                }
            },
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            labels: {
                rotate: -45,
                rotateAlways: true,
                style: {
                    fontFamily: "Roboto",
                    fontSize: "11px",
                }
            },
            categories: details?.gst_month?.month?.slice(0, data),
            title: {
                text: '',
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
        },
        yaxis: [{
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: "11px",
                },
                formatter: function (val, index) {
                    return numDifferentiation(val);
                }
            },
        }],
        title: {
            text: undefined
        },
        series: [
            {
                color: "#1c314c",
                name: 'GST Payable',
                type: 'column',
                data: details?.gst_month?.gst_payable?.slice(0, data)
            },
            {
                color: "#8ac8d5",
                name: 'GST Receivables',
                type: 'column',
                data: details?.gst_month?.gst_recieveble?.slice(0, data)
            }
        ]
    };

    return (
        <>
            {
                details?.one_month?.payable_gst?.total === 0 && details?.one_month?.recieveble_gst?.total === 0 ? <NoData /> :
                    <div ref={netGST} className={clsx(classes.totalChartDiv, classes.netGst)}>
                        <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                            <span className={classes.lastDays}>{`Last ${data} ${data > 1 ? 'Months' : 'Month'}`}</span>
                            <span className={classes.lastDaysRadio}>
                                <RadioGroup
                                    row
                                    defaultValue={"one_month"}
                                    onChange={(e) => handleChange(e.target.value)}>
                                    <FormControlLabel value="one_month" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="1" />
                                    <FormControlLabel value="three_months" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="3" />
                                    <FormControlLabel value="twelve_months" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="12" />
                                </RadioGroup>
                            </span>
                            <span className={classes.hamburgerMenu}>
                                <Dropdown
                                    placement="bottomLeft"
                                    trigger={['click']}
                                    overlay={
                                        <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                            <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                            <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                        </Menu>
                                    }>
                                    <Image src={hamburgerMenu} preview={false} />
                                </Dropdown>
                            </span>
                        </div>
                        <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: "calc(100% - 22px)", marginTop: 10 }}>
                            {
                                datas !== '' &&
                                <div className={classes.netGstSliderContent}>
                                    <Row gutter={10} className={clsx(classes.netGstSliderContentRow, classes.bg_blue)}>
                                        <Col span={24}><div className={clsx(classes.textAlignCenter)}>
                                            <div>
                                                <h3>GST Payable</h3>
                                                <p className={classes.bold}>₹ {currencyFormat(datas?.payable_gst?.total)}</p>
                                            </div></div>
                                        </Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>SGST</h3>
                                                <p>₹ {currencyFormat(datas?.payable_gst?.sgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>CGST</h3>
                                                <p>₹ {currencyFormat(datas?.payable_gst?.cgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>IGST</h3>
                                                <p>₹ {currencyFormat(datas?.payable_gst?.igst)}</p>
                                            </div></div></Col>
                                    </Row>
                                    <Row gutter={10} className={clsx(classes.netGstSliderContentRow, classes.bg_green)}>
                                        <Col span={24}><div className={clsx(classes.textAlignCenter)}>
                                            <div>
                                                <h3>GST Receivables</h3>
                                                <p className={classes.bold}>₹ {currencyFormat(datas?.recieveble_gst?.total)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>SGST</h3>
                                                <p>₹ {currencyFormat(datas?.recieveble_gst?.sgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>CGST</h3>
                                                <p>₹ {currencyFormat(datas?.recieveble_gst?.cgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>IGST</h3>
                                                <p>₹ {currencyFormat(datas?.recieveble_gst?.igst)}</p>
                                            </div></div></Col>

                                    </Row>
                                    <Row gutter={10} className={clsx(classes.netGstSliderContentRow, classes.bg_yellow, classes.colorBoxSha)}>
                                        <Col span={24}><div className={clsx(classes.textAlignCenter)}>
                                            <div>
                                                <h3>Net GST</h3>
                                                <p className={classes.bold}>₹ {currencyFormat(datas?.net_gst?.total)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>SGST</h3>
                                                <p>₹ {currencyFormat(datas?.net_gst?.sgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>CGST</h3>
                                                <p>₹ {currencyFormat(datas?.net_gst?.cgst)}</p>
                                            </div></div></Col>
                                        <Col span={8}><div className={clsx(classes.textAlignRight)}>
                                            <div>
                                                <h3>IGST</h3>
                                                <p>₹ {currencyFormat(datas?.net_gst?.igst)}</p>
                                            </div></div></Col>

                                    </Row>
                                </div>
                            }
                            <div className={classes.netGstChart}>
                                <div className={classes.chartDiv}>
                                    {
                                        datas && datas?.payable_gst && <ReactApexChart options={chartData} series={chartData.series} height={"230"} />
                                    }
                                    {
                                        mobileDevice && <><div className={classes.invoiceAmount}>GST Amount</div>
                                            <div className={classes.invoiceMonths}>Months</div></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>

    )
}